import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react';

import ObjALaUneHomeFormation from './inc/ObjALaUneHomeFormation';
import ObjAGagnerHomeFormation from './inc/ObjAGagnerHomeFormation';

import '../assets/css/0010_sections/0420_section_content_formation.css';
import '../assets/css/0010_sections/0450_section_home_carrousel_tabs_formation.css';

class PageBrand_CarrouselsPushs extends Component {
	render() {
        const { scDatas } = this.props.fields.data;

		return (<>{scDatas && scDatas.ListContentForPage?.some(x => true) && <>
			<section className="obj_section section_content_formation">
				<div className="ctn_section">
					<div className="ctn_row">
						{scDatas.ListContentForPage[0].ListFolderPushsALaUne[0].ListPushs && <ObjALaUneHomeFormation scDatasPushs={scDatas.ListContentForPage[0].ListFolderPushsALaUne[0].ListPushs} scDatasBrandName={scDatas.pageTitle.value}/>}
						{scDatas.ListContentForPage[0].ListFolderPushsAGagner[0].ListPushs && <ObjAGagnerHomeFormation scDatasPushs={scDatas.ListContentForPage[0].ListFolderPushsAGagner[0].ListPushs} scDatasBrandName={scDatas.pageTitle.value}/>}
					</div>
				</div>
		    </section>
        </>}</>)
	}
}

export default withTranslation()(withSitecoreContext()(PageBrand_CarrouselsPushs));